module.exports = __webpack_public_path__ + "fonts/ReadexPro-Medium.ae2b7f6.ttf";